import { render, staticRenderFns } from "./DataTables.vue?vue&type=template&id=a6061a60&scoped=true"
import script from "./DataTables.vue?vue&type=script&lang=js"
export * from "./DataTables.vue?vue&type=script&lang=js"
import style0 from "./DataTables.vue?vue&type=style&index=0&id=a6061a60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6061a60",
  null
  
)

export default component.exports